<template>
  <div class="policies"
       id="dynamicsRC">
    <homeHead></homeHead>
    <!-- 导航 组件-->
    <homeNav></homeNav>
    <!-- 导航 组件-->
    <div class="main_box">
      <div class="search_page">
        <div class="pageInfo">
          <div class="info_title">搜索结果</div>
          <div class="infoList">
            <ul v-if="infoList.length>0">
              <li @click="gotoDetail(item,item.id)"
                  v-for="(item,index) in infoList"
                  :key="index">
                <div v-html="addColor(item.title)">{{addColor(item.title)}}</div>
                <span>{{$dateToConver(item.publish_at,2)}}</span>
              </li>
            </ul>
            <div class="hint"
                 v-else>暂无相关搜索结果</div>
          </div>
          <div class="page"
               v-if="infoList.length>0">
            <el-pagination @current-change="handleCurrentChange"
                           :current-page.sync="page"
                           background
                           layout="prev, pager, next"
                           :total="total"
                           :page-size="page_size"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <homeFooter></homeFooter>
  </div>
</template>

<script>
import merge from "webpack-merge";
import homeHead from "@/components/Public/head.vue";
import homeNav from "@/components/Public/nav.vue";
import homeFooter from "@/components/Public/footer.vue";
export default {
  components: {
    homeHead,
    homeNav,
    homeFooter
  },
  metaInfo () {
    let currentTitle = '';
    currentTitle = this.$store.state.webInfo.title + "-搜索结果";
    return {
      title: currentTitle
    };
  },
  data () {
    return {
      total: 0,
      page: 1,
      page_size: 20,
      infoList: "",
      title: this.$route.query.title,
      last_page: 0,
      positionData: []
    };
  },
  methods: {
    //切换分页
    handleCurrentChange (val) {
      let url = "";
      url = this.$url.document.list;
      this.pageSync(val);
      this.$db
        .get(url, {
          title: this.title,
          page_size: this.page_size,
          page: this.page
        })
        .then(c_resp => {
          let data = c_resp.data;
          if (c_resp.code == 200) {
            this.infoList = data.data;
          }
        }).catch(err => {
          console.log(err);
        });
    },
    //跳到尾页
    goEnd () {
      let url = this.$url.document.list;
      this.$db
        .get(url, {
          title: this.title,
          page_size: this.page_size,
          page: this.last_page
        })
        .then(c_resp => {
          let data = c_resp.data;
          if (c_resp.code == 200) {
            this.infoList = data.data;
            this.page = this.last_page;
          }
        }).catch(err => {
          console.log(err);
        });
    },

    gotoDetail (item, id) {
      if (item.type == 4) {
        this.channelGoto(item)
        return false
      }
      //导航ID
      this.$router.push({
        name: "details",
        query: { newsId: id }
      });
    },

    getData () {
      this.$db
        .get(this.$url.document.list, {
          title: this.title,
          page: this.page,
          page_size: this.page_size
        })
        .then(resp => {
          if (resp.code == 200) {
            console.log("this.infoList", this.infoList);
            this.infoList = resp.data.data;
            this.total = resp.data.total;
            this.last_page = resp.data.last_page;
          }
        }).catch(err => {
          console.log(err);
        });
    },
    addColor (texts) {
      return texts.replace(
        this.title,
        '<font color="red">' + this.title + "</font>"
      );
    },
    pageSync (val) {
      let query = this.$route.query;
      this.$router.push({
        query: merge(this.$route.query, { 'page': val })
      });
    }
  },
  created () {
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
      this.pageSync(this.$route.query.page);
    }
    else this.pageSync(1);
    this.getData();
  },
  watch: {
    "$route.query.title": function (val) {
      this.title = val;
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>
.main_box {
  padding: 15px 0px;
  .search_page {
    width: 1200px;
    margin: 0px auto;
    padding: 15px 0px;
    min-height: 500px;
    display: flex;
    justify-content: space-between;
    .sidebar {
      width: 230px;
      .sidebar_title {
        width: 210px;
        height: 70px;
        padding-top: 24px;
        background: #c60002;
        color: #fff;
        font-size: 24px;
        padding-left: 20px;
        > span {
          font-size: 12px;
          text-transform: uppercase;
          display: block;
          color: #ede2c5;
          padding-top: 2px;
          letter-spacing: 1px;
        }
      }
      > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        > li {
          width: 230px;
          .sidebar_info {
            width: 190px;
            border-bottom: 1px solid #cfcfcf;
            padding: 10px 20px;
            overflow: hidden;
            font-size: 14px;
            cursor: pointer;
          }
          .sidebar_info:hover {
            background-color: #f3b105;
            color: #fff;
            font-weight: 550;
          }
        }
        .active {
          background-color: #f3b105;
          color: #fff;
          font-weight: 550;
        }
      }
    }
    .pageInfo {
      width: 100%;
      padding-bottom: 90px;
      position: relative;
      .info_title {
        padding-left: 20px;
        height: 24px;
        line-height: 24px;
        font-size: 22px;
        color: #d10000;
        margin-bottom: 20px;
      }
      .infoList {
        > ul {
          list-style: none;
          margin: 0;
          padding: 0;
          border-top: #d9d9d9 1px solid;
          min-height: 500px;
          > li {
            line-height: 40px;
            height: 40px;
            position: relative;
            font-size: 14px;
            padding-left: 10px;
            border-bottom: #d9d9d9 1px solid;
            color: #333;
            display: flex;
            justify-content: space-between;
            > div {
              float: left;
            }
            > div:hover {
              color: #d10000;
              cursor: pointer;
            }
            > span {
              font-size: 12px;
              color: #999;
              float: right;
            }
          }
        }
        .hint {
          color: #333;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .page {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
      }
    }
  }
}
// /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #f3b105;
// }
// /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
//   color: #f3b105;
// }
// /deep/ .el-pagination span:not([class*="suffix"]):hover {
//   background-color: #f3b105;
//   color: #fff;
// }
</style>


// WEBPACK FOOTER //
// src/components/search/index.vue